<template>
  <div style="margin-top: 170px">
    <div
      class="row d-flex justify-content-center align-items-center"
    >
      <div class="col-md-8 col-lg-6 col-xl-5">
        <div class="card">
          <div class="card-body">
            <div class="p-2">
              <div class="text-center mx-auto">
                <div class="avatar-md mx-auto">
                  <div class="avatar-title rounded-circle bg-light">
                    <i class="bx bxs-log-out-circle h1 mb-0 text-primary"></i>
                  </div>
                </div>
                <div class="p-2 mt-4">
                  <h4 class="fw-semibold">Sign Out</h4>
                  <p class="text-muted">Are you sure you want to sign out?</p>
                  <div class="mt-4">
                    <form enctype="multipart/form-data">
                      <input
                        type="hidden"
                        name="csrfmiddlewaretoken"
                        value="Vb4vNRDHMMeLO6CN4STVd0rC9WIbkW2TVztiDlOsqS5ZJvboQhMh9QFnpWoZxi1q"
                      />
                      <button
                        type="button"
                        class="btn btn-success"
                        @click="onLogout"
                      >
                        Sign Out
                      </button>

                      <button
                        type="button"
                        class="btn btn-default"
                        @click="$router.go(-1)"
                      >
                        Cancel
                      </button>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- end container -->
    </div>
  </div>
</template>

<script>
import { router } from '../router'
import { authenticationService } from '../services/authentication.service'

import Card from '@/components/Card'
export default {
  name: 'Logout',
  components: { Card },
  data () {
    return {}
  },
  created () {
    // redirect to home if already logged in
    if (!authenticationService.currentUserValue) {
      return router.push('/login')
    }
  },
  methods: {
    onLogout () {
      authenticationService.logout()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/Logout.vue